<div
  *ngIf="isRunning() && isAllowed"
  class="cs-rest-timer-expanded"
  (click)="onBackdrop()"
>
  <div class="cs-rest-timer-expanded__panel" (click)="$event.stopPropagation()">
    <div class="cs-rest-timer-expanded__name">{{ exerciseName() }}</div>
    <div class="cs-rest-timer-expanded__time">
      {{ isExpired() ? LL.workouts.restTimer.done() : timeLabel() }}
    </div>
    <div class="cs-rest-timer-expanded__controls">
      <button
        type="button"
        class="cs-rest-timer-expanded__step"
        [disabled]="!canDecrement()"
        (click)="onDecrement()"
      >{{ LL.workouts.restTimer.adjustMinus() }}</button>
      <button
        type="button"
        class="cs-rest-timer-expanded__skip"
        (click)="onSkip()"
      >{{ LL.workouts.restTimer.skip() }}</button>
      <button
        type="button"
        class="cs-rest-timer-expanded__step"
        [disabled]="!canIncrement()"
        (click)="onIncrement()"
      >{{ LL.workouts.restTimer.adjustPlus() }}</button>
    </div>
  </div>
</div>
